import React from "react";
import { Button } from "@/components/ui/button";
import { WarningOctagon, ArrowClockwise } from "@phosphor-icons/react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI ErrorBoundary caught:", error, info);
  }
  reset = () => {
    this.setState({ hasError: false });
    if (this.props.onReset) this.props.onReset();
  };
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-[60vh] flex items-center justify-center p-8">
          <div className="max-w-md text-center card-matte p-8">
            <div className="h-12 w-12 rounded-xl bg-[#6B3DFF]/12 flex items-center justify-center mx-auto mb-4">
              <WarningOctagon size={26} className="brand-text" weight="fill" />
            </div>
            <div className="font-head text-xl font-semibold mb-1.5">Something went wrong on this page</div>
            <p className="text-sm text-[#9a9a9a] mb-5">
              An unexpected error occurred while rendering. Your data is safe — try reloading this section.
            </p>
            <div className="flex items-center justify-center gap-2">
              <Button data-testid="error-retry-btn" onClick={this.reset} className="bg-[#6B3DFF] hover:bg-[#A56CFF] text-white">
                <ArrowClockwise size={15} className="mr-1.5" weight="bold" /> Try again
              </Button>
              <Button data-testid="error-reload-btn" variant="ghost" onClick={() => window.location.reload()} className="text-[#9a9a9a] hover:text-white">
                Reload page
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
